<template>
  <span
    v-if="items.length > 0"
    class="bg-primary-container inline-flex items-center gap-0.5 rounded-full px-2 py-1.5"
  >
    <span
      v-for="(dot, dotIndex) in items"
      :key="dotIndex"
      class="h-2 w-2 rounded-full"
      :class="[
        isFilled(dot.value) && 'bg-primary',
        !isFilled(dot.value) && 'border-outline-variant border-2',
      ]"
    />
  </span>
</template>

<script lang="ts" setup>
  interface ScaleDot {
    readonly value: number
  }

  const props = defineProps<{
    items: ReadonlyArray<ScaleDot>
    value?: number | null
  }>()

  const isFilled = (dotValue: number) => props.value != null && dotValue === props.value
</script>
